import { useState } from 'react';
import PropTypes from 'prop-types';

import { getClassNames } from '../../../../utils/util';

import Image from '../../image/Image';
import ImageCarousel from '../../image-carousel/ImageCarousel';

import { ReactComponent as StarEmptyIcon } from '../../../../resources/icons/star-empty.svg';
import { ReactComponent as StarFilledIcon } from '../../../../resources/icons/star-filled.svg';

import './listing-card.scss';

const ListingCard = ({
  title,
  description,
  images,
  bookmarked,
  post,
  hideActions,
  bookmarkListing,
  navigateToProduct,
}) => {
  const [selectedImageIndex, setSelectedImageIndex] = useState(undefined);

  const additionalImageCount = images.length - 1;

  const renderImage = () => {
    if (images && images[0]) {
      return (
        <div className={getClassNames('listing-card__image-container', { post })}>
          <Image
            onClick={() => setSelectedImageIndex(0)}
            className={getClassNames('listing-card__image-container__image', { post })}
            externalReference={images[0]}
            alt={title}
          />
          {additionalImageCount > 0 && (
            <div className="listing-card__image-container__additional">
              <p>
                +{additionalImageCount} {additionalImageCount === 1 ? 'Image' : 'Images'}
              </p>
            </div>
          )}
        </div>
      );
    }

    return (
      <div className={getClassNames('listing-card__placeholder', { post })}>
        <p>No Image</p>
      </div>
    );
  };

  return (
    <>
      <div className={getClassNames('listing-card', { post })}>
        {renderImage()}

        <div className="listing-card__content">
          <div>
            <p className={getClassNames('listing-card__content__title', { post })}>{title}</p>
            <p className={getClassNames('listing-card__content__description', { post })}>{description}</p>
          </div>

          {!hideActions && (
            <div className="listing-card__content__buttons">
              {bookmarkListing && (
                <button onClick={bookmarkListing}>
                  Bookmark This
                  {bookmarked ? <StarFilledIcon /> : <StarEmptyIcon />}
                </button>
              )}
              {navigateToProduct && (
                <button onClick={navigateToProduct}>
                  View Product Page<p>{'>'}</p>
                </button>
              )}
            </div>
          )}
        </div>
      </div>

      {selectedImageIndex !== undefined && (
        <ImageCarousel images={images} startIndex={selectedImageIndex} setStartIndex={setSelectedImageIndex} />
      )}
    </>
  );
};

ListingCard.propTypes = {
  title: PropTypes.string.isRequired,
  description: PropTypes.string.isRequired,
  images: PropTypes.arrayOf(PropTypes.string),
  post: PropTypes.bool,
  hideActions: PropTypes.bool,
  bookmarkListing: PropTypes.func,
  navigateToProduct: PropTypes.func,
};

ListingCard.defaultProps = {
  images: [],
  post: false,
  hideActions: false,
  bookmarkListing: undefined,
  navigateToProduct: undefined,
};

export default ListingCard;
